var isIE = function isIE() {
  if (typeof window === 'object') {
    var ieMethodContext = !!window.MSInputMethodContext;
    var ieDocumentMode = !!document.documentMode;

    if (ieMethodContext && ieDocumentMode) {
      return true;
    }
  }

  return false;
};

export default isIE;